import { ExternalLink } from 'lucide-react';
import type { ContentSource } from '../../lib/roadCode';
import { cx } from '../../components/charte';

/** Sources de la règle : article du Code de la route (lien Légifrance) ou autre référence. */
export function SourcesLine({ sources, className }: { sources?: ContentSource[]; className?: string }) {
  if (!sources?.length) return null;
  return (
    <p className={cx('text-[12px] leading-relaxed text-secondary', className)}>
      Source{sources.length > 1 ? 's' : ''} :{' '}
      {sources.map((source, index) => (
        <span key={source.label}>
          {index > 0 && ' · '}
          {source.url ? (
            <a href={source.url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-0.5 underline underline-offset-2 hover:text-primary-700">
              {source.label}
              <ExternalLink size={11} aria-hidden />
              <span className="sr-only"> (Légifrance, nouvel onglet)</span>
            </a>
          ) : (
            source.label
          )}
        </span>
      ))}
    </p>
  );
}
